<template>
  <iframe :src="src" frameborder="0"></iframe>
</template>

<script>
/**
 * 路由参数
 *
 * @param {string} keyword - 类型
 * @param {string} region - 关键字
 */

export default {
  computed: {
    src() {
      const url = new URL('https://apis.map.qq.com/tools/poimarker');
      url.searchParams.append('type', '1');
      url.searchParams.append('key', 'OT5BZ-JWCWT-X6JXY-LHQXH-KSPOO-3BB44');
      url.searchParams.append('referer', 'demo');
      const query = {
        ...this.$route.query,
        keyword: this.$route.query.keyword,
        region: this.$route.query.region || '沈阳市',
      };
      Object.keys(query).forEach((field) => {
        url.searchParams.append(field, query[field]);
      });
      return url.href;
    },
  },
};
</script>

<style lang="less" scoped>
iframe {
  display: block;
  width: 100%;
  height: 100%;
  border: none;
}
</style>



// WEBPACK FOOTER //
// src/components/map/map.vue